"use strict";

exports.__esModule = true;
exports.ActionButtonElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _UserActions = require("../../UserActions");
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
var _common = require("../common");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _reactIntl = require("react-intl");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var NoActionErrorText = _styledComponents["default"].div.withConfig({
  displayName: "ActionButtonElement__NoActionErrorText",
  componentId: "sc-1jn9mx6-0"
})(["display:flex;justify-content:center;align-items:center;font-size:17px;font-weight:500;"]);
// An action from the next-gen design: a rounded white card button with a
// soft shadow that fills the slot it is given.
var ActionButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "ActionButtonElement__ActionButton",
  componentId: "sc-1jn9mx6-1"
})(["", " .", "{display:flex;align-items:center;", "}"], (0, _whenModern.whenModern)((0, _styledComponents.css)(["&.", "{box-sizing:border-box;width:100%;height:100%;max-height:88px;min-height:56px;touch-action:manipulation;-webkit-tap-highlight-color:transparent;justify-content:center;gap:8px;background:#ffffff;background-image:none;border:0;border-radius:12px;box-shadow:", ";color:#1b2227;font-weight:600;font-size:16px;padding:0 20px;transition:box-shadow 120ms ease,transform 120ms ease,background-color 120ms ease;&:hover{background:#f8fafb;box-shadow:", ";transform:translateY(-1px);}&:active{box-shadow:", ";transform:translateY(0);}}"], _core.Classes.BUTTON, (0, _Theme.val)("ButtonShadow"), (0, _Theme.val)("ButtonShadowHover"), (0, _Theme.val)("ButtonShadow"))), _core.Classes.BUTTON_TEXT, (0, _whenModern.whenModern)("white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"));
var ActionButtonElementWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ActionButtonElement__ActionButtonElementWrapper",
  componentId: "sc-1jn9mx6-2"
})(["display:flex;justify-content:center;align-items:center;overflow-y:auto;"]);

/**
 * Displays a label for a section.
 */
var ActionButtonElement = exports.ActionButtonElement = function ActionButtonElement(props) {
  var userActions = _react["default"].useContext(_userActionsContext.UserActionsContext);
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var onClickAction = props.onClickAction,
    label = props.label;
  if (!onClickAction) {
    return /*#__PURE__*/_react["default"].createElement(NoActionErrorText, {
      style: Object.assign({}, (0, _common.getWidgetPositionProps)(props))
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ActionButtonElement.NoAction.helperText",
      defaultMessage: "Please select an action"
    }));
  }
  var userAction = userActions.find(function (action) {
    return action.name === onClickAction.name;
  });
  return /*#__PURE__*/_react["default"].createElement(ActionButtonElementWrapper, _extends({
    style: Object.assign({}, (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetFontProps)(props, "css"))
  }, (0, _common.getWidgetInteractionProps)(props)), /*#__PURE__*/_react["default"].createElement(_UserActions.UserAction, _extends({
    label: label
  }, onClickAction), function (_ref) {
    var invoke = _ref.invoke;
    return /*#__PURE__*/_react["default"].createElement(ActionButton, {
      large: true,
      onClick: invoke,
      "data-testid": "ActionButton-" + userAction.name
    }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      margin: "5px",
      icon: userAction.icon,
      iconSize: modern ? 20 : 16,
      alt: userAction.name
    }), label || userAction.label);
  }));
};